import gql from 'graphql-tag';

import client from '../graphqlAPI';

const GET_USERS_LIST = gql`
query getUsersList($active: Boolean, $email: String, $name: String, $idNumber: String, $socialnetwork: String, $verified: String, $role: String, $startDate: String, $finishDate: String, $from: Int, $to: Int, $sortingField: String, $sortingType: Int, $getTotal: Boolean, $hasAddress: String, $sendMagazine: String, $includeEligibility: Boolean, $duplicatesOnly: String) {
  getUsersList(active: $active, email: $email, name: $name, idNumber: $idNumber, socialnetwork: $socialnetwork, verified: $verified, role: $role, startDate: $startDate, finishDate: $finishDate, from: $from, to: $to, sortingField: $sortingField, sortingType: $sortingType, getTotal: $getTotal, hasAddress: $hasAddress, sendMagazine: $sendMagazine, includeEligibility: $includeEligibility, duplicatesOnly: $duplicatesOnly) {
    isAuth
    total
    query
    users {
      _id
      email
      name
      lastname
      nickname
      idNumber
      createdAt
      updatedAt
      acceptedConditions
      validationDate
      validatedAt
      recoverDate
      recoveredAt
      verified
      active
      deleted
      language
      serverCountry
      socialnetwork
      roles
      originPost
      phoneNumber
      newsletter
      newsletterCode
      isInSplio
      isSpotifyLinked
      stripeCustomerId
      eligibleForMagazine
      duplicateScore
      duplicateReasons
      duplicatePartner
      duplicateSubscriptionEmail
      loggedFrom {
        lastSeen
        CountryIp
        ip
        system
        active
      }
      address {
        name
        lastname
        street
        streetNumber
        apartment
        city
        province
        postalCode
        country
      }
      history {
        type
        date
        action
        data
      }
      paymentMethods {
        provider
        token
        createdAt
        preferred
        card {
          last4
          brand
          exp_month
          exp_year
        }
      }
      favouriteArtists
      favoriteConcerts
      social {
        key
        name
        link
      }
    }
  }
}
`;

const getUsersList = async (variables) => {
  try {
    const result = await client.query({
      query: GET_USERS_LIST,
      variables,
      errorPolicy: 'all',
      fetchResults: true,
      fetchPolicy: 'no-cache',
    })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    const { data: { getUsersList: usersListData } } = result;

    if (usersListData) {
      return usersListData;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: getUsersList = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: getUsersList Error: ${error}`);
    return null;
  }
};

export default getUsersList;
